import { mapState } from 'vuex';
import { apiCallers } from '@/api/apiRequest';
import { email, required } from 'vuelidate/lib/validators';

import NRadio from '@/components/common/n-radio';
import NText from'@/components/common/n-text.vue';
import ScrollHandler from '@/mixins/scrollHandler.js';

export default {
  components: {
    NRadio,
    NText
  },

  mixins: [
    ScrollHandler
  ],

  data: () => ({
    themeId: 0,
    themes: [
      {
        id: 1,
        text: 'Feuerwehr'
      },
      {
        id: 2,
        text: 'Sicherheit & Prävention'
      },
      {
        id: 3,
        text: 'Kunst & Kultur / Stiftungen'
      },
      {
        id: 4,
        text: 'Soziales'
      },
      {
        id: 5,
        text: 'Sport'
      },
      {
        id: 6,
        text: 'Umwelt & Nachhaltigkeit'
      },
      {
        id: 7,
        text: 'Bildung / Wissenschaft'
      },
      {
        id: 8,
        text: 'Gemeinnütziger Verein'
      },
      {
        id: 9,
        text: 'Bildungseinrichtung'
      },
      {
        id: 10,
        text: 'Event / Aktion'
      },
      {
        id: 11,
        text: 'Stiftung'
      },
      {
        id: 12,
        text: 'Privates Projekt'
      },
      {
        id: 13,
        text: 'Firma / Gewerbe'
      }
    ],

    organizationId: 0,
    organizations: [
      {
        id: 1,
        text: 'Freiwillige Feuerwehr'
      },
      {
        id: 2,
        text: 'Jugendfeuerwehr'
      },
      {
        id: 3,
        text: 'Berufsfeuerwehr'
      },
      {
        id: 4,
        text: 'Kreis- oder Stadtfeuerwehrverband'
      },
    ],

    supportId: 0,
    supports: [
      {
        id: 1,
        text: 'Geräteförderung',
        details: `Die Versicherungskammer fördert keine Geräte, Schutzkleidung oder Fahrzeuge. Bitte schicken Sie uns hierzu keine Anträge. Die „Schwimmsauger“ der Versicherungskammer Bayern wurden über die Kreis- und Stadtfeuerwehrverbände verteilt. Einzelne Schwimmsauger können in begrenztem Umfang über unsere Vertriebspartner vor Ort beantragt und an die örtliche Feuerwehr ausgeben werden.
          Die Aktion „Mobiler Rauchverschluss“ ist beendet, diese können nicht mehr beantragt werden.`
      },
      {
        id: 2,
        text: 'Veranstaltung (z.B. Jubiläum, Kreisfeuerwehrtag; Jugendzeltlager)',
        details: `Leider können wir aufgrund der vielen Anfragen und Aktivitäten nicht jede Veranstaltung der Feuerwehr finanziell unterstützen.
          Sie haben jedoch als Feuerwehr die Möglichkeit kostenloses Infomaterial anzufordern (Link: <a href="https://www.vkb.de/content/services/schaden-verhueten/publikationen/" target="blank">https://www.vkb.de/content/services/schaden-verhueten/publikationen/</a> Feuerwehren tragen als Versicherungsnummer bitte 0000 ein).<br>
          Veranstaltungen, insbesondere der Jugendfeuerwehr, auf Landkreis- oder Bezirksebene sind grundsätzlich förderfähig. Anfragen hierzu richten Sie bitte an <a href="mailto:feuerwehr@vkb.de">feuerwehr@vkb.de</a>`
      },
      {
        id: 3,
        text: 'Werbeanzeige, beispielsweise für Jubiläums-Festschrift',
        details: 'Es besteht in begrenztem Umfang die Möglichkeit Werbeanzeigen in Festschriften zu schalten. Bitte schicken Sie einen Antrag mit Angabe ihrer Konditionen an <a href="mailto:feuerwehr@vkb.de">feuerwehr@vkb.de</a>'
      },
      {
        id: 4,
        text: 'Brandschutzerziehung',
        details: `Die Versicherungskammer Bayern stellt jeder Feuerwehr in Bayern und der Pfalz kostenlos Publikationen zur Schadenverhütung und Brandschutzerziehung zur Verfügung. Diese finden Sie hier (<a href="https://www.vkb.de/content/services/schaden-verhueten/publikationen/" target="blank">LINK zur Publikationsbestellung)</a><br>
          Darüber hinaus wurden Kreis- und Stadtfeuerwehrverbände mit Modellrauchhäusern und Brandschutzerziehungskoffern ausgestattet. Diese können meist von allen Feuerwehren dort ausgeliehen werden. An einzelne Feuerwehren können wir diese Ausstattung wegen der begrenzten Stückzahl leider nicht verteilen.`
      },
      {
        id: 5,
        text: 'Sonstiges',
        details: 'Sonstige Anfragen richten Sie bitte an <a href="mailto:feuerwehr@vkb.de">feuerwehr@vkb.de</a>'
      },
    ],

    organ_details: '',
    email: '',
    email_sent: false,

    errorMessages: {
      organ_details: {
        required: 'Bitte geben Sie Ihre Organisation ein.',
      },

      email: {
        required: 'Bitte geben Sie Ihre E-Mail-Adresse ein.',
        email: 'Bitte geben Sie Ihre gültige E-Mail-Adresse ein.'
      },
    },
  }),

  computed: {
    ...mapState([
      'appConfigs'
    ]),

    config () {
      return this.appConfigs[this.$options.configIndex] || {};
    },

    apiRequest () {
      return apiCallers[this.config.app];
    },
  },

  methods: {
    isInvalid (field) {
      const validity = this.$v[field];
      if (!validity || !validity.$dirty) {
        return false;
      }

      return this.$v[field].$invalid;
    },

    getErrorMessage (field) {
      const validity = this.$v[field];
      if (!validity || !validity.$dirty) {
        return;
      }

      const error_key = Object.keys(validity.$params).find(k => validity[k] === false);

      return error_key
        ? this.errorMessages[field][error_key]
        : '';
    },

    onSelectTheme (id) {
      this.themeId = id;
      this.$v.$reset();

      if (id !== 1) {
        this.organizationId = 0;
        this.supportId = 0;
      }
    },

    onSendEmail () {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      const theme = this.themes.find(t => t.id === this.themeId);

      const params = {
        theme: theme.text,
        description_organisation: this.organ_details,
        email: this.email
      };

      this.apiRequest
        .post(this.config.paths.send_email, params)
        .then(() => {
          this.email_sent = true;
        });
    }
  },

  validations: {
    organ_details: {
      required
    },

    email: {
      required,
      email
    }
  }
};


// WEBPACK FOOTER //
// ./src/apps/sponsoring/logic.js